"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var widgets_1 = require("@tableau/widgets");
var RowHeaderCell_1 = require("./RowHeaderCell");
var BodyCell_1 = require("./BodyCell");
var GridSelection_1 = require("./GridSelection");
var Utils_1 = require("./Utils");
var BodyRow = /** @class */ (function (_super) {
    __extends(BodyRow, _super);
    function BodyRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMouseEnter = function () {
            if (!!_this.props.row) {
                _this.props.handleMouseEnter(_this.props.row);
            }
        };
        _this.handleRowHeaderCellClick = function (e) {
            if (!!_this.props.row && _this.props.onRowClick) {
                _this.props.onRowClick(_this.props.row.data, _this.props.rowIdx, e);
            }
        };
        _this.handleRowClick = function (e) {
            if (e.defaultPrevented) {
                return;
            }
            if (!!_this.props.row && _this.props.onRowClick && e.target === ReactDOM.findDOMNode(_this)) {
                _this.props.onRowClick(_this.props.row.data, _this.props.rowIdx, e);
            }
        };
        return _this;
    }
    BodyRow.prototype.isCellSelected = function (cell) {
        if (!this.props.selectionData) {
            return false;
        }
        // If row is selected, the cell is selected
        if (this.props.isSelected) {
            return true;
        }
        // If the selectionData is IndexBasedSelectionData then test it, otherwise return false
        if (this.props.isSelectionDataIndexBased) {
            return GridSelection_1.GridSelection.isCellSelected(cell, this.props.selectionData);
        }
        else {
            return false;
        }
    };
    BodyRow.prototype.render = function () {
        var columnWidths = this.props.columnWidths || {};
        var color = null;
        if (this.props.isSelected) {
            color = BodyRow.SelectedColor;
        }
        else if (this.props.isHovered) {
            color = BodyRow.HoverColor;
        }
        else if (this.props.isFocused) {
            color = BodyRow.FocusedColor;
        }
        var borderBottomStyle = this.props.showHorizontalGridLines ? '1px solid #e6e6e6' : '';
        var style = {
            height: this.props.rowOuterHeight,
            paddingLeft: this.props.leftMargin || 0,
            boxSizing: 'border-box',
            borderBottom: borderBottomStyle,
            backgroundColor: color,
            whiteSpace: 'nowrap'
        };
        if (!!this.props.row && this.props.row.rowStyle) {
            Utils_1.assign(style, this.props.row.rowStyle);
        }
        if (!!this.props.row && !!this.props.rowStylist) {
            var args = {
                row: this.props.row,
                rowIdx: this.props.rowIdx,
                isFocused: this.props.isFocused,
                isHovered: this.props.isHovered,
                isSelected: this.props.isSelected,
                style: style
            };
            this.props.rowStylist(args);
        }
        var attrs = {
            className: 'tb-react-dg-brow',
            style: style,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.props.handleMouseLeave,
            'aria-selected': this.props.isSelected
        };
        /**
         * 733183: "Scrolling past ~2000 rows causes a fatal rendering error"
         * The row prop can be undefined at runtime. This specifically occurs if the rowStore does not return the rows associated with the requested start
         * and end row indexes. As such, we can hit a situation where our DataGrid is expecting defined rows for row indexes that were not actually returned
         * from the rowStore. When this happens we render a styled empty BodyRow.
         */
        if (!this.props.row) {
            return React.createElement("div", __assign({}, attrs));
        }
        // -1: leave room for border - TODO should come from TabStyles.Sizing.BorderWidth
        var rowInnerHeight = this.props.rowOuterHeight - 1;
        // tslint:disable-next-line
        var cells = [];
        if (this.props.showRowHeaders && this.props.colStartIdx === 0) {
            cells.push(RowHeaderCell_1.RowHeaderCell.element({
                key: "hcell",
                height: rowInnerHeight,
                isSelected: this.props.isSelected,
                onRowHeaderCellClick: this.handleRowHeaderCellClick,
                rowType: RowHeaderCell_1.RowHeaderCell.RowType.Body,
                testId: 'hcell'
            }));
        }
        for (var colIdx = this.props.colStartIdx; colIdx <= this.props.colEndIdx; colIdx++) {
            var col = this.props.cols[colIdx];
            var shouldReportWidth = !col.preferredWidth && this.props.measuredColumnWidths[col.name] === undefined;
            cells.push(BodyCell_1.BodyCell.element({
                key: col.name,
                col: col,
                row: this.props.row,
                rowIdx: this.props.rowIdx,
                colIdx: colIdx,
                value: this.props.row.data[col.dataKey],
                width: shouldReportWidth ? undefined : columnWidths[col.name],
                height: rowInnerHeight,
                reportWidthFn: shouldReportWidth ? this.props.reportWidthFn : undefined,
                isSelected: this.isCellSelected({ row: this.props.rowIdx, col: colIdx }),
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                showVerticalGridLines: this.props.showVerticalGridLines
            }));
        }
        return (React.createElement(widgets_1.PointerEventWrapper, { pointerClick: this.handleRowClick },
            React.createElement("div", __assign({}, attrs), cells)));
    };
    BodyRow.displayName = 'DataGridBodyRow';
    BodyRow.element = React.createFactory(BodyRow);
    return BodyRow;
}(React.PureComponent));
exports.BodyRow = BodyRow;
(function (BodyRow) {
    BodyRow.SelectedColor = '#d4e1ed';
    BodyRow.HoverColor = '#f5f5f5';
    BodyRow.FocusedColor = '#f5f5f5';
})(BodyRow = exports.BodyRow || (exports.BodyRow = {}));
exports.BodyRow = BodyRow;
//# sourceMappingURL=BodyRow.js.map